export const ERROR_CATALOG = {
  // Internal Errors
  CL_INTERNAL_SERVER_ERROR: {
    message: 'Something went wrong on our end. Please try again later.',
    severity: 'error'
  },

  // Document Errors
  DOCUMENT_NOT_FOUND: {
    message: 'The requested document could not be found.',
    severity: 'error'
  },
  DOCUMENT_FETCH_FAILED: {
    message: 'Failed to load documents. Please try again.',
    severity: 'error'
  },

  // Fallback
  DEFAULT: {
    message: 'An unexpected error occurred. Please try again.',
    severity: 'error'
  }
} as const;

export type ErrorCode = keyof typeof ERROR_CATALOG;
export type ErrorSeverity = 'error' | 'warn' | 'warning' | 'info' | 'success';

export interface MappedError {
  message: string;
  severity: ErrorSeverity;
  code: ErrorCode;
}
